// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"3be05fbc","72":"f0d122de","124":"c2e13704","575":"cb44e648","667":"9933aa7d","697":"66b6b636","811":"b1da14ee"}[chunkId] + ".chunk.js";
};